var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFbIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fb icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1-Vaitality-homes-page-Copy",
    transform: "translate(-1096.000000, -3599.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 3455.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb-icon",
    transform: "translate(1096.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#FFFFFF",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "facebook-(3)",
    transform: "translate(16.500000, 11.000000)",
    fillRule: "nonzero",
    fill: "#385C8E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.38053531,11.7171914 L2.96641535,11.7171914 L2.96641535,21.6451641 C2.96641535,21.8411875 3.13670939,22 3.34690458,22 L7.73137723,22 C7.94157242,22 8.11186647,21.8411875 8.11186647,21.6451641 L8.11186647,11.7639844 L11.0845941,11.7639844 C11.2778797,11.7639844 11.4405253,11.6287187 11.4625953,11.449668 L11.9140865,7.79470312 C11.9264807,7.69415625 11.8923389,7.5934375 11.8201851,7.51798437 C11.7479853,7.44248828 11.6446385,7.39926172 11.5361774,7.39926172 L8.11205077,7.39926172 L8.11205077,5.108125 C8.11205077,4.41748828 8.51078579,4.06725 9.29738209,4.06725 C9.40948312,4.06725 11.5361774,4.06725 11.5361774,4.06725 C11.7463726,4.06725 11.9166667,3.90835156 11.9166667,3.71241406 L11.9166667,0.357457031 C11.9166667,0.161433594 11.7463726,0.00262109375 11.5361774,0.00262109375 L8.45074977,0.00262109375 C8.42900226,0.0016328125 8.38066935,0 8.30943704,0 C7.77408897,0 5.91324872,0.0980117188 4.44331071,1.35910156 C2.81464355,2.75661719 3.04105722,4.42986328 3.09514954,4.71998828 L3.09514954,7.39917578 L0.380489235,7.39917578 C0.170294044,7.39917578 0,7.55798828 0,7.75401172 L0,11.3623125 C4.60752283e-05,11.558293 0.170340119,11.7171914 0.38053531,11.7171914 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.1e3a9ffd31865b6396d0a28d4055a317.svg";
export { ForwardRef as ReactComponent };